module.exports = "/_next/static/images/40619386a370d9d41087df4a5d33e754-slide-2.png.webp";